module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="column column-first">\n	<figure>\n		<picture>\n			<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n			<img loading="lazy" src="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100 }) ))==null?'':_.escape(__t))+
'" alt="">\n		</picture>\n	</figure>\n	<div class="player-info">\n		<div class="player-name">\n			<i class="player-status '+
((__t=( status ))==null?'':_.escape(__t))+
'"></i>\n			<span>'+
((__t=( first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( last_name ))==null?'':_.escape(__t))+
'</span>\n		</div>\n		';
 if(is_coach_enabled){ 
__p+='\n			<div class="player-stats-coach">\n				';
 if(has_assistant_coach) { 
__p+='\n					<div class="proj-score">\n						PROJ.<b>'+
((__t=( stats.proj_score ))==null?'':_.escape(__t))+
'</b> BE.<b>'+
((__t=( stats.break_even ))==null?'':_.escape(__t))+
'</b>\n					</div>\n					';
 if(stats.bye_round_id){ 
__p+='\n						<div class="bye-rd">BYE RD. <span>'+
((__t=( stats.bye_round_id ))==null?'':_.escape(__t))+
'</span></div>\n					';
 } 
__p+='\n				';
 } else { 
__p+='\n					<!-- User has no assistant coach but trigger to show coach data -->\n					<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n				';
 } 
__p+='\n			</div>\n		';
 } else { 
__p+='\n			<div>\n				<span class="player-squad-name">\n					'+
((__t=( squad_name ))==null?'':_.escape(__t))+
'\n				</span>\n				<span class="player-positions">\n					<span> | </span>\n					<span>'+
((__t=( position_names.join(' | ') ))==null?'':_.escape(__t))+
'</span>\n					<span> | </span>\n					<span>'+
((__t=( _.currencyFormat(cost, '') ))==null?'':_.escape(__t))+
'</span>\n				</span>\n			</div>\n		';
 } 
__p+='\n	</div>\n</div>\n<div class="stats column '+
((__t=( is_coach_stats ? 'coach-stats' : '' ))==null?'':_.escape(__t))+
'">\n	';
 if(is_coach_stats && has_assistant_coach || !is_coach_stats){ 
__p+='\n		'+
((__t=( sorted_stats ))==null?'':_.escape(__t))+
'\n	';
 } else { 
__p+='\n		<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n	';
 } 
__p+='\n</div>\n<div class="column column-last">\n	';
 if(is_locked){ 
__p+='\n		<a class="btn-locked">\n			<i class="ion-ios-locked"></i>\n		</a>\n	';
 } else { 
__p+='\n		<a class="js-add btn-add">\n			<i class="ion-android-add"></i>\n		</a>\n	';
 } 
__p+='\n</div>';
}
return __p;
};
